module.exports = __webpack_public_path__ + "full-screen-icon-c38753a949610fd087ea.png";